goog.provide('el8.appanalytics.reports.bulkLetters');

goog.require('el8.appanalytics.ReportTab');
goog.require('el8.template.appanalytics.reports.bulkLetters');
goog.require('el8.appanalytics.dialog.viewBulkLetterPatients');
goog.require('el8.appanalytics.dialog.bulkLetterDownload');

el8.appanalytics.reports.bulkLetters.create = function(showTabFn) {
    var page = 1;
    var loading = false;
    var container = $('#bulk-letters-section');
    var actionsMenu = new el8.uiwidget.NewActionsMenu({
        container: container.parent(),
        anchorTop: container,
        menuId: 'bulk-letter-report-actions-menu'
    });

    var bulkLetters = {};

    var that = new el8.appanalytics.ReportTab({
        trigger: $('.report-title[_section="bulk-letters"]'),
        container: container,
        initFn: function() {
          container.on('click', '.next-page-trigger',  function(e) {
              if (!loading) { // Prevent multiple clicks as next page is loading
                  page += 1;
                  loading = true;
                  that.load();
              }
          }).on('click', '.prev-page-trigger',  function(e) {
              if (!loading) {
                  page -= 1;
                  loading = true;
                  that.load();
              }
          }).on('click', '.bulk-letter-pt-list-trigger',  function (e) {
              var elem = $(e.target);
              var listName = elem.data('list');
              el8.appanalytics.dialog.viewBulkLetterPatients.show({
                  bulkLetter: bulkLetters[elem.data('id')],
                  listName: listName
              });
          }).on('click', '.bulk-letter-actions-trigger',  function (e) {
              actionsMenu.display(
                  // Positioning is all weird when I use e.target instead of its
                  // parent div. Don't ask me why.
                  $(e.target).parent(),
                  null,
                  { top: 24, left: 0 },
                  _makeActionMenu(bulkLetters[$(e.target).data('id')])
              );
              e.preventDefault();
              return false;
          }).on('click', '.create-new-bulk-letter-link',  function() {
              showTabFn('mu-population');
          });
        },
        loadFn: function(callbackFn, onCompleteFn) {
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('bulkLettersList', [page]),
                success: function(data) {
                    _.each(data['bulk_letters'], function(letter) {
                        bulkLetters[letter.id] = letter;
                    });

                    container.html(
                        el8.template.appanalytics.reports.bulkLetters.content({
                            currentPage: data['current_page'],
                            numPages: data['num_pages'],
                            bulkLetters: data['bulk_letters']
                        })
                    );
                },
                complete: function() {
                    loading = false;
                    if (callbackFn) { callbackFn(); }
                    if (onCompleteFn) { onCompleteFn(); }
                }
            });
        }
    });

    var super_show = that.show.bind(that);
    that.show = function() {
        super_show();
        if (that._isLoaded) {
            // Automatically reload on show, but don't double-load the first time
            that.load();
        }
    };

    function _makeActionMenu(bulkLetter) {
        var menu = [];
        menu.push({
            actionText: 'View letter',
            actionFn: function() {
                window.open(el8.service.urls.get('bulkLetterPreview', [bulkLetter.id]));
            }
        });
        if (bulkLetter.print_pdf_status !== 'no_output') {
            menu.push({
                actionText: 'Print letters',
                actionFn: function() {
                    el8.appanalytics.dialog.bulkLetterDownload.show(
                        bulkLetter, 'print'
                    );
                }
            });
        }
        menu.push({
            actionText: 'Download as CSV',
            actionFn: function() {
                el8.appanalytics.dialog.bulkLetterDownload.show(
                    bulkLetter, 'contact-list'
                );
            }
        });
        return menu;
    }

    return that;
};
